<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;margin-bottom: 40px;">
          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              快查成绩郑重承诺：</div>
            <div style="font-size:16px;padding-top: 10px;font-weight: bold;margin:10px;">
              平台侧不会泄露学生成绩,且对老师发布的成绩也不做任何加工和计算,也即老师发什么系统显示什么。请广大老师监督和反馈。反馈和投诉微信:wx34424698</div>
          </div>



          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;color:red;">
            本软件是免费软件，发成绩和查成绩均免费，无任何限制。</div>

          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;margin-top: 40px;">
            Excel成绩单要求:
          </div>
          <div style="font-size:18px;padding-top: 10px;margin:10px;">
            发布成绩的Excel文件必须包括<span style="color:red;">姓名</span>和<span style="color:red;">学号</span>两个列。</div>

          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;margin-top: 40px;">
            发布方式:
          </div>
          <div style="font-size:18px;padding-top: 10px;margin:10px;">
            支持微信小程序端发布和电脑网页端发布。
          </div>


          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;margin-top: 40px;">
            查询方式:
          </div>
          <div style="font-size:18px;padding-top: 10px;margin:10px;">
            支持微信小程序端和QQ小程序端。建议尽量使用微信小程序。
          </div>


          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;margin-top: 40px;">
            老师客服联系方式:
          </div>
          <div style="font-size:18px;padding-top: 10px;margin:10px;">
            <div>微信号：wx34424698 </div>
            <div style="margin-top: 10px;">紧急电话：19909408114 </div>
          </div>

          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;margin-top: 40px;">
            家长客服联系方式:
          </div>
          <div style="font-size:18px;padding-top: 10px;margin:10px;">
            请家长在小程序中联系客服。各位老师不要将老师客服联系方式转发给家长，老师客服不接待家长咨询服务。
          </div>


        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/read_me.vue